export const decodeImage = (encodedString: string): string => {
    return `data:image/jpeg;base64,${encodedString}`;
  };